export default __webpack_public_path__ + "static/media/Youtube.359ade9e.svg";